module.exports = __webpack_public_path__ + "static/ballot-30a30405cfd81304edf2b38b111a6556.png";